const colors = {
  Received: 'info',
  Processing: 'primary',
  Processed: 'success',
  Failed: 'warning',
  Rejected: 'error',
  Exhausted: 'error',
  Undeveloped: 'secondary',

  Skipped: 'secondary',
}

export const webhookStatusColor = value => colors[value] || 'secondary'

export const webhookBody = payload => {
  try {
    const parsed = JSON.parse(payload)

    return typeof parsed === 'string' ? parsed : JSON.stringify(parsed, null, 2)
  } catch {
    return payload
  }
}
